import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { UserActivitySortOrder } from '../../../UserActivity.meta';
import { FilterAccordion } from '../../FilterAccordion/FilterAccordion';

interface Props {
  sortOrder: UserActivitySortOrder;
  isExpanded: boolean;
  onToggle: () => void;
  onSortOrderChange: (order: UserActivitySortOrder) => void;
}

const SORT_OPTIONS = [
  {
    order: UserActivitySortOrder.Newest,
    label: 'Newest First',
    icon: 'far fa-arrow-up',
  },
  {
    order: UserActivitySortOrder.Oldest,
    label: 'Oldest First',
    icon: 'far fa-arrow-down',
  },
] as const;

export const SortBySection = ({ sortOrder, isExpanded, onToggle, onSortOrderChange }: Props) => (
  <FilterAccordion
    id="sort-filter-sort"
    title="Sort By"
    isExpanded={isExpanded}
    onToggle={onToggle}
    zIndex={1}
  >
    <Box
      display="flex"
      flexDirection="column"
      px="16"
      pb="16"
      css={({ theme }) => ({ gap: theme.space['8'] })}
    >
      {SORT_OPTIONS.map(({ order, label, icon }) => (
        <Button
          key={order}
          variant="link"
          variantColor={sortOrder === order ? 'primary' : 'neutral'}
          leftIcon={icon}
          my="4"
          css="width: fit-content;"
          onClick={() => onSortOrderChange(order)}
          aria-pressed={sortOrder === order}
        >
          {label}
        </Button>
      ))}
    </Box>
  </FilterAccordion>
);
